import { themeColors } from "@/utils/themeColors";
import { X } from "lucide-react";
import CircularButton, { CircularButtonProps } from "@/components/CircularButton";
import Image from "next/image";
import { ASSETS_URL } from "@/config/deployConstants";

const KaiChatFloatingIcon = ({
    isOpen = false,
    style,
    containerStyle,
    ...btnProps
}: {
    isOpen?: boolean;
    containerStyle?: React.CSSProperties;
} & CircularButtonProps) => {
    return (
        <div
            style={{ position: "sticky", bottom: "3rem", right: "3rem", ...containerStyle }}
            data-testid="auto-id-292d5407-8cfe-4660-8e52-7795bb15e1e6">
            <CircularButton
                {...btnProps}
                radius="6rem"
                style={{
                    backgroundColor: themeColors.neutralBlack,
                    transition: "background-color 0.2s",
                    ...style,
                }}>
                {isOpen ? (
                    <X size={35} color={themeColors.neutralWhite} />
                ) : (
                    <Image
                        src={`${ASSETS_URL}/images/ai-summarizer-kai.svg`}
                        width={44}
                        height={33}
                        alt="robot"
                        style={{ flexShrink: 0 }}
                    />
                )}
            </CircularButton>
        </div>
    );
};

export default KaiChatFloatingIcon;
